import React, { useEffect, useRef } from 'react';

const ParticleEffect = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');

        let colors = [
            `rgb(102, 211, 153)`,
            `rgb(30, 143, 83)`,
            `rgb(11, 78, 42)`
        ];
        let time = 0;
        let gravityStrength = 10;
        let spawnTimer = 0;
        let spawnInterval = 100;
        let type = 0;
        let particles = [];
        let mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2, out: true };

        const resizeCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };
        resizeCanvas();

        window.addEventListener('resize', resizeCanvas);

        const handleMouseMove = (e) => {
            mouse = {
                x: e.clientX,
                y: e.clientY,
                out: false,
            };
        };

        const handleMouseOut = () => {
            mouse.out = true;
        };

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseout', handleMouseOut);

        const newParticle = () => {
            type = type ? 0 : 1;
            let colorSelection = Math.floor(3 * Math.random());

            particles.push({
                x: mouse.x,
                y: mouse.y,
                xv: type ? 12 * Math.random() - 6 : 16 * Math.random() - 8,
                yv: type ? 12 * Math.random() - 6 : 16 * Math.random() - 8,
                c: type
                    ? colors[colorSelection]
                    : 'rgb(255,255,255)',
                s: type ? 5 + 10 * Math.random() : 1,
                a: 1,
            });
        };

        const startLoop = (newTime) => {
            time = newTime;
            requestAnimationFrame(loop);
        };

        const loop = (newTime) => {
            draw();
            calculate(newTime);
            requestAnimationFrame(loop);
        };

        const draw = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            for (let i = 0; i < particles.length; i++) {
                const p = particles[i];
                ctx.globalAlpha = p.a;
                ctx.fillStyle = p.c;
                ctx.beginPath();
                ctx.arc(p.x, p.y, p.s, 0, 2 * Math.PI);
                ctx.fill();
            }
        };

        const calculate = (newTime) => {
            const dt = newTime - time;
            time = newTime;

            if (!mouse.out) {
                spawnTimer += dt < 100 ? dt : 100;
                for (; spawnTimer > 0; spawnTimer -= spawnInterval) {
                    newParticle();
                }
            }

            const particleOverflow = particles.length - 700;
            if (particleOverflow > 0) {
                particles.splice(0, particleOverflow);
            }

            for (let i = 0; i < particles.length; i++) {
                const p = particles[i];
                if (!mouse.out) {
                    const x = mouse.x - p.x;
                    const y = mouse.y - p.y;
                    let a = x * x + y * y;
                    a = a > 100 ? gravityStrength / a : gravityStrength / 100;
                    p.xv = (p.xv + a * x) * 0.99;
                    p.yv = (p.yv + a * y) * 0.99;
                }
                p.x += p.xv;
                p.y += p.yv;
                p.a *= 0.99;
            }
        };

        requestAnimationFrame(startLoop);

        return () => {
            window.removeEventListener('resize', resizeCanvas);
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseout', handleMouseOut);
        };
    }, []);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
            }}
        />
    );
};

export default ParticleEffect;